<script lang="ts">
export default {
    name: 'ResetPasswordInputs',
    props: {
        data: { type: Object, required: true },
        translationName: { type: String, required: true },
        hideSection : { type : Boolean, required : false}
    },
    emits: ['updateData'],
    data() {
        return {
            passwordConfirm: null,
            visible: false,

        }
    },
    computed: {
        rules() {
            return [
                () => {
                    if (!this.data?.k && this.data?.password)
                        return true

                    return 'Le mot de passe est obligatoire'
                },
                () => {
                    if ((this.data?.password === this.passwordConfirm) || (!this.data.password && !this.passwordConfirm))
                        return true

                    return 'Les mots de passe doivent être les mêmes.'
                },
                () => {
                    if (!this.data?.password || this.data?.password.length > 13)
                        return true

                    return 'Le mot de passe doit avoir une longueur minimale de 14 caractères'
                },
                // REGEX HAS ONE NUMBER, ONE LOWERCASE, ONE UPPERCASE, ONE SPECIAL, FALSE WHEN SPACE
                () => {
                    const regex = new RegExp(/(?=.*\d)(?=.*[a-z])(?=.*[A-Z])((?=.*\W)|(?=.*_))^[^ ]+$/g)
                    
                    if (this.data?.password && regex.test(this.data.password))
                        return true

                    return 'Le mot de passe doit contenir au moins un chiffre, une lettre minuscule, une lettre majuscule, un caractère spécial'
                },
            ]
        },

    },
    methods: {
        forceValidate() {
            this.$refs.password.validate()
            this.$refs.confirm.validate()
        },
        isValidated () {
            this.forceValidate()
            let validation = []
            this.rules.forEach( rule => {
                if (rule() !== true) {
                    validation.push(rule())
                }
            })
            return !validation.length
        }
    },
}
</script>

<template>
    <FormSection v-if="($permissionCheck('user_canResetPassword') && data.k) || !data.k" title="Informations de sécurité" with-borders-color="danger" :hide-section>
        <p class="mb-2" v-if="($permissionCheck('user_canResetPassword') && data.k)">
            À remplir uniquement si vous souhaitez définir un nouveau mot de passe.
        </p>

        <div v-if="!data.guid">
            <label class="v-label">
                {{ $translate(`${translationName}.password`) }} 
                <span v-html="$config.public.form_label_required_text || '*'" />
            </label>
            <div class="text-caption text-medium-emphasis">
                Le mot de passe doit contenir au moins un chiffre, une lettre minuscule, une lettre majuscule, un caractère spécial et doit avoir une longueur minimale de 14 caractères.
            </div>
            <v-row>
                <v-col>
                    <v-text-field
                        ref="password"
                        :model-value="data.password"
                        :type="visible ? 'text' : 'password'"
                        variant="outlined"
                        density="compact"
                        :rules="rules"
                        @update:model-value="forceValidate(); $emit('updateData', { [`password`]: $event })"
                    />
                </v-col>
                <v-col cols="2" class="px-0">
                    <v-btn
                        color="primary"
                        class="my-1"
                        @click="visible = !visible" 
                        aria-label="Afficher ou cacher le mot de passe"
                    >
                        <v-icon :icon="visible ? 'mdi-eye-off' : 'mdi-eye'"></v-icon>
                    </v-btn>
                </v-col>
            </v-row>
        </div>
        <div v-if="!data.guid">
            <label class="v-label">
                {{ $translate(`${translationName}.passwordConfirm`) }}
                <span v-html="$config.public.form_label_required_text || '*'" />
            </label>

            <v-text-field
                ref="confirm"
                v-model="passwordConfirm"
                :rules="rules"
                variant="outlined"
                density="compact"
                :type="visible ? 'text' : 'password'"

                @input="forceValidate"
            />
        </div>
    </FormSection>
</template>
